module.exports = __webpack_public_path__ + "ploni-aaa-500.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ploni-aaa-500.otf
// module id = 1199
// module chunks = 10